



















import { Component, Prop, Vue } from 'vue-property-decorator';
import Setting from './Setting.vue';
import Warning from '@/components/page/Warning.vue';
import { PipelineService } from '@/api/com/MetaPattern/APP/MDA/Pipeline/PipelineService';
import { EnumPipelinePhaseMD } from '@/api/com/MetaPattern/APP/MDA/Pipeline/EnumPipelinePhase';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';

@Component({
  components: {
    Setting,
    Warning
  }
})
export default class APPPipeline extends Vue {
  @Prop() transferData!: any; // 结构：Json，{app: value; productId: value; appId: value; appKey: value}

  /** 全流程发布 */
  publishFull() {
    this.$confirm('将使用最新的元数据及设置完成流水线的全流程发布，请确定是否继续', '流水线提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (this.transferData.appKey) {
        const loadingText = '正在努力执行，请耐心等待...';
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // PipelineService.PublishAPPFullAsync(this.transferData.appKey)
        PipelineService.PublishProductFullAsync('', true, this.transferData.appKey, true, [this.transferData.appKey], this.transferData.includeFront)
          .then(res => {
            if (res) {
              // 测试的时候，需要重新更新设置
              IDEContext.instance.getUserInfoAsync(IDEContext.instance.curAccountInfo.accountId, IDEContext.instance.curUser.id);
              this.$message({ type: 'success', message: '流水线发布成功!' });
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${this.transferData.appKey}] 流水线发布成功。`);
            }
            loading.close();
          })
          .catch((error: any) => {
            // Important！！这里的错误处理与常规不一致
            try {
              const errInfo = JSON.parse(error);
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', '--------应用发布发生错误：');
              EnumPipelinePhaseMD.getItems().forEach(item => {
                if (errInfo[item.name]) {
                  this.$store.dispatch('ModuleMD/setOutputMessagesAction', `[${item.displayName}] 阶段共有错误数： ${errInfo[item.name].length}`);
                  errInfo[item.name].forEach((errLine: any) => {
                    this.$store.dispatch('ModuleMD/setOutputMessagesAction', `[${item.displayName}] ${errLine}`);
                  });
                }
              });
              this.$message({ type: 'error', message: '流水线发布失败！原因详见输出窗口！' });
            } catch {
              this.$message({ type: 'error', message: '流水线发布失败，发生不明原因！' });
            }
            loading.close();
          });
      }
    });
  }

  /** 转化为UI模型 */
  appConvertToUIModel() {
    if (this.transferData.app) {
      const app = this.transferData.app as APP;
      const loadingText = '正在努力同步UI模型，请耐心等待...';
      const loading = this.$loading({
        lock: true,
        text: loadingText,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      PipelineService.APPConvertToUIAsync(app.aPPKey)
        .then(uiModelComponents => {
          if (uiModelComponents && uiModelComponents.length > 0) {
            let index = 0;
            uiModelComponents.forEach(uiModelComponent => {
              index++;
              const findUIModel = app.uIModelComponents.find(item => item.designId === uiModelComponent.designId);
              if (findUIModel) {
                findUIModel.copyFrom(uiModelComponent, false);
                findUIModel.persistenceStatus = EnumPersistenceStatus.None;
              } else {
                uiModelComponent.persistenceStatus = EnumPersistenceStatus.None;
                uiModelComponent.aPP = app;
                app.uIModelComponents.push(uiModelComponent);
              }

              EventBus.$emit('removeTab', uiModelComponent.designId); // 关闭多文档中已经打开的组件
              if (index === uiModelComponents.length) {
                this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', uiModelComponent.designId);
                this.$store.dispatch('ModuleMD/setCurMDElementAction', { element: uiModelComponent });
              }
            });
            this.$message({ type: 'success', message: '组件同步成功，请重新打开组件加载内容!' });
            this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 同步UI模型操作成功。`);
            // ElementUIHelper.expendNode(this.$refs.tree as Tree, app.designId);
          }
          loading.close();
        })
        .catch((error: any) => {
          this.$message({ type: 'error', message: '组件同步失败!原因是：' + error });
          this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 发布失败！原因是：${error}`);
          loading.close();
        });
    }
  }

  /** 转化为DB模型 */
  appConvertToDBModel() {
    if (this.transferData.app) {
      const app = this.transferData.app as APP;
      const loadingText = '正在努力同步DB模型，请耐心等待...';
      const loading = this.$loading({
        lock: true,
        text: loadingText,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      PipelineService.APPConvertToDBAsync(app.aPPKey)
        .then(dbModelComponents => {
          if (dbModelComponents && dbModelComponents.length > 0) {
            this.$message({ type: 'success', message: '组件同步成功!' });
          }
          loading.close();
        })
        .catch((error: any) => {
          this.$message({ type: 'error', message: '组件同步失败!原因是：' + error });
          this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 发布失败！原因是：${error}`);
          loading.close();
        });
    }
  }

  /** 生成代码 */
  generateCode() {
    this.$confirm('将使用最新的元数据及设置生成代码，请确定是否继续', '生成代码提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (this.transferData.app) {
        const app = this.transferData.app as APP;
        const loadingText = '正在努力生成代码，请耐心等待...';
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        PipelineService.GenerateCodeAsync(app.aPPKey)
          .then(res => {
            if (res) {
              this.$message({ type: 'success', message: '生成代码成功!' });
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 生成代码成功。`);
            }
            loading.close();
          })
          .catch((error: any) => {
            this.$message({ type: 'error', message: '生成代码失败!原因是：' + error });
            this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 生成代码失败！原因是：${error}`);
            loading.close();
          });
      }
    });
  }

  /** 创建DDL脚本 */
  createDDL() {
    this.$confirm('将使用最新的元数据及设置生成DDL脚本，请确定是否继续', '生成代码提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (this.transferData.app) {
        const app = this.transferData.app as APP;
        const loadingText = '正在努力生成DDL脚本，请耐心等待...';
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        PipelineService.CreateDDLAsync(app.aPPKey)
          .then(res => {
            if (res) {
              this.$message({ type: 'success', message: '生成DDL脚本成功!' });
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 生成DDL脚本成功。`);
            }
            loading.close();
          })
          .catch((error: any) => {
            this.$message({ type: 'error', message: '生成DDL脚本失败!原因是：' + error });
            this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 生成DDL脚本失败！原因是：${error}`);
            loading.close();
          });
      }
    });
  }

  /** 发布应用 */
  publishAPP() {
    const message = '此操作将创建或升级数据库，并发布应用以及其下属的组件，不可恢复，可能需要几分钟，是否继续?';
    this.$confirm(message, '发布提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (this.transferData.app) {
        const app = this.transferData.app as APP;
        const loadingText = '正在努力发布应用，请耐心等待...';
        const loading = this.$loading({
          lock: true,
          text: loadingText,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        PipelineService.PublishDBAsync(app.aPPKey)
          .then(res => {
            if (res) {
              this.$message({ type: 'success', message: '应用发布成功!' });
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 发布成功。`);
            }
            loading.close();
          })
          .catch((error: any) => {
            this.$message({ type: 'error', message: '发布应用失败!原因是：' + error });
            this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 发布失败！原因是：${error}`);
            loading.close();
          });
      }
    }).catch(() => {
      // 取消发布
    });
  }
}
